import CalculationDashboard from './CalculationDashboard';

const SalesTaxCalculationsTab = ({
  corporationId,
}: {
  corporationId: number;
}) => {
  return <CalculationDashboard corporationId={corporationId} />;
};

export default SalesTaxCalculationsTab;
